import React, { useState } from "react";
import CustomModal from "../Common/CustomModal";
import { Box, Grid } from "@mui/material";
import axiosInstance from "../../utils/config/config";
import { useSelector } from "react-redux";
import { CustomInput } from "../Common/CustomInput";
import {
  ConfirmationNumberOutlined,
  LocationOnOutlined,
  TagSharp,
  TitleSharp,
} from "@mui/icons-material";
import { colors } from "../../theme/theme";
import CustomDatePicker from "../Common/CustomDatePicker";
import CustomDropdown from "../Common/CustomDropdown";
import CustomTagInput from "../Common/CustomTagInput";
import ImageUploadInput from "../Common/ImageUploadInput";
import { CustomBtn } from "../Common/CustomBtn";

const CreateForumModal = ({
  open,
  onClose,
  setLoading,
  setErrorState,
  setSuccess,
}) => {
  const { userData } = useSelector((state) => state.user);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [image, setImage] = useState(null);
  const [categories, setCategories] = useState([]);
  const [date, setDate] = useState(null);
  const [type, setType] = useState("");

  const handlePublish = async () => {
    setErrorState({
      error: false,
      errorMsg: "",
    });

    if (!title || !description || !image) {
      setErrorState({
        error: true,
        errorMsg: "Please fill all the fields",
      });
      return;
    }

    try {
      setLoading(true);

      onClose();
      const response = await axiosInstance.post("/forum/createForum", {
        title: title,
        description: description,
        image_url: image,
        userId: userData?.id,
        date: date,
        location: location,
        status: "active",
        type: type,
        categories: categories,
      });

      if (response?.status === 200) {
        setErrorState({
          error: false,
          errorMsg: "",
        });
        setTitle("");
        setDescription("");
        setDate(null);
        setLocation("");
        setSuccess(true);
        setCategories([]);
        setType("");
        setImage(null);
      }
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.data?.response?.message || "Failed to create forum",
      });
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <CustomModal open={open} onClose={onClose} title="Create Forum">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "50%",
          margin: "0 auto",
        }}
      >
        <CustomInput
          label={"Forum Title"}
          value={title}
          handleChange={(e) => setTitle(e.target.value)}
          placeholder={"Enter forum title"}
          Icon={TitleSharp}
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
        />
        <CustomInput
          label={"Forum Description"}
          value={description}
          handleChange={(e) => setDescription(e.target.value)}
          placeholder={"Enter forum description"}
          noIcon
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
          textArea
        />
        <Grid container spacing={2}>
          {/* <Grid item size={{ xs: 12, md: 6 }}>
            <CustomDatePicker
              label={"Forum Date"}
              value={date}
              setValue={setDate}
              placeholder={"Select forum date"}
              width={"100%"}
              mT={2}
              borderColor={colors.secondary}
              color={colors.primary}
              iconColor={"rgba(25,34,52,0.5)"}
            />
          </Grid> */}
          <Grid item size={{ xs: 12 }}></Grid>
        </Grid>
        <CustomDropdown
          label={"Forum Type"}
          placeholder={"Select forum type"}
          value={type}
          setValue={setType}
          data={[
            { label: "All", value: "all" },
            { label: "Popular", value: "popular" },
            { label: "Recent", value: "recent" },
          ]}
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
          color={colors.primary}
          Icon={ConfirmationNumberOutlined}
        />
        <CustomTagInput
          label={"Categories"}
          hashTags={categories}
          setHashTags={setCategories}
          placeholder={"Add categories"}
          width={"100%"}
          mT={2}
          borderColor={colors.secondary}
          color={colors.primary}
          Icon={TagSharp}
        />

        <ImageUploadInput
          image={image}
          setImage={setImage}
          width={"90%"}
          label={"Forum Image"}
        />

        <CustomBtn
          text={"Publish"}
          width={"100%"}
          height={"50px"}
          mt={2}
          mb={2}
          onClick={handlePublish}
        />
      </Box>
    </CustomModal>
  );
};

export default CreateForumModal;
